import { render, staticRenderFns } from "./RegulationList.vue?vue&type=template&id=7c4fe982"
import script from "./RegulationList.vue?vue&type=script&lang=js"
export * from "./RegulationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports